import { supabase } from '../supabaseClient';

export async function cleanupDeletedCadernoFiles() {
  const { data, error } = await supabase.from('caderno_arquivos_excluidos').select('id,bucket,path');
  if (error) throw error;
  for (const file of data || []) {
    const removed = await supabase.storage.from(file.bucket).remove([file.path]);
    if (removed.error) throw removed.error;
    const acknowledged = await supabase.from('caderno_arquivos_excluidos').delete().eq('id', file.id);
    if (acknowledged.error) throw acknowledged.error;
  }
}

export async function deleteCadernoRecord(functionName, parameters) {
  const { error } = await supabase.rpc(functionName, parameters);
  if (error) throw error;
  try {
    await cleanupDeletedCadernoFiles();
    return '';
  } catch (error) {
    // The database deletion committed; keep the durable cleanup request for retry.
    return `Registro excluído, mas há arquivos aguardando remoção. A limpeza será tentada ao recarregar o Caderno. ${error.message || 'Falha no armazenamento.'}`;
  }
}
